// src/forms/customerConfig.js

const CustomerConfig = [
  { 
    name: 'is_company',
    label: 'Customer Type',
    type: 'checkbox',
    toggleType: { onLabel: 'Company', offLabel: 'Individual' },
    defaultValue: true, // Default to true for Company
    rules: {},
  },
  { 
      name: 'name',
      label: 'Customer Name',
      type: 'text',
      defaultValue: '',
      rules: { required: 'Customer name is required' },
  },
  {
      name: 'contact_person',
      label: 'Contact Person',
      type: 'text',
      defaultValue: '',
      rules: { required: 'Contact is required' },
  },
  {
      name: 'phone_number', 
      label: 'Telephone',
      type: 'number',
      defaultValue: '',
      placeholder: '',
      rules: {required: 'Telephone is required'},
  },
  {
      name: 'email',
      label: 'Email',
      type: 'text',
      defaultValue: '',
      placeholder: 'Email',
      rules: {required: 'Email is required'},
  },
  {
      name: 'country_id',
      label: 'Country',
      type: 'select',
      defaultValue: '',
      rules: {required: 'Country is required'},
  },
  {
      name: 'region_id',
      label: 'Region',
      type: 'select',
      defaultValue: '',
      placeholder: 'Region',
  },
  {
      name: 'district_id',
      label: 'City',
      type: 'select',
      defaultValue: '',
      placeholder: 'City',
  },
  {
      name: 'suburb',
      label: 'Suburb',
      type: 'text',
      defaultValue: '',
      placeholder: 'Suburb',
  },
  {
      name: 'street',
      label: 'Street address',
      type: 'text',
      defaultValue: '',
      placeholder: 'Street Address',
  },
  {
      name: 'created_time',
      label: 'Engaged Since',
      type: 'date',
      defaultValue: '',
      placeholder: 'Engaged since',
  },
  {
      name: 'gps_link', // Corrected from 'gps_linkLink'
      label: 'GPS Link',
      type: 'text',
      defaultValue: '',
      placeholder: 'GPS Link',
  },
];

export default CustomerConfig;
